// extracted by mini-css-extract-plugin
module.exports = {"icon":"idt-photoprintsui_icon__39nuv","spinner":"idt-photoprintsui_spinner__j_hnn"};